import React from "react";

import "./styles.scss";
import qs from "qs";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import Button from "shared/components/Button";
import Space from "shared/components/Space";
import { NAME_SPACES } from "shared/locals/constants";
import { PATHS } from "utils/constants";

const ErrorScreen = () => {
  const history = useHistory();
  const location = useLocation();
  const { description } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  const { t } = useTranslation(NAME_SPACES.ERRORS, { keyPrefix: "ERROR_PAGE" });

  return (
    <div className={"error-page"}>
      <div className={"form"}>
        <p className={"title"}>{t("TITLE")}</p>
        <Space h={64} />
        <p className={"small-title"}>{description || t("MESSAGE")}</p>
        <Space h={64} />
        <Button
          text={t("BACK")}
          onClick={() => history.push(PATHS.FILE.HOME)}
        />
        <Space h={64} />
      </div>
    </div>
  );
};

export default ErrorScreen;
